// extracted by mini-css-extract-plugin
export var textInput = "_iw-0";